import React, { Component } from 'react';
import './App.css';

import ViewStart from './View/start';
import ViewSelect from './View/select';
import ViewGame from './View/game';
import ViewEnd from './View/end';
import {AnnouncePlayer, VoicePlayer, EffectPlayer} from './lib/VoicePlayer'

//build時はpackage.jsonのurlも確認

class App extends Component {
    constructor() {
        super();
        this.handleClickStart  = this.handleClickStart.bind(this);
        this.handleClickOthers = this.handleClickOthers.bind(this);
        this.handleClickSelect = this.handleClickSelect.bind(this);
        this.handleClickRepeat = this.handleClickRepeat.bind(this);
        this.handleClickAnswer = this.handleClickAnswer.bind(this);
        this.handleClickCard   = this.handleClickCard.bind(this);
        this.handleClickModal  = this.handleClickModal.bind(this);
        this.handleClickClose  = this.handleClickClose.bind(this);
        this.handleClickPrevious = this.handleClickPrevious.bind(this);
        this.handleClickNext = this.handleClickNext.bind(this);
        this.handleClickFinish = this.handleClickFinish.bind(this);
        this.handleClickYes = this.handleClickYes.bind(this);
        this.handleClickNo = this.handleClickNo.bind(this);
        this.handleClickRestart = this.handleClickRestart.bind(this);
        this._play = this._play.bind(this);

        this.announceplayer = new AnnouncePlayer();
        this.voiceplayer = new VoicePlayer();
        this.effectplayer = new EffectPlayer();

        this.state = {
            page: 'start',
            current: null,
            remaining: [...VoicePlayer.CARD],
            read: [],
            count: null
        }
    }
    ArrayShuffle() {
        console.log(`remaining: [${this.state.remaining}]`);
        var Shuffle = [...this.state.remaining];
        for(var i = Shuffle.length -1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i+1));
            var tmp = Shuffle[i];
            Shuffle[i] = Shuffle[j];
            Shuffle[j] = tmp;
        }
        console.log(`Shuffle: [${Shuffle}]`);
        this.setState({ remaining: Shuffle });
        this.state.count =  this.state.remaining.length;
    }
    StopSound() {
        this.announceplayer.stop();
        this.voiceplayer.stop();
        this.effectplayer.stop();
    }
    handleClickStart() {
        console.log('handle click start');
        this.ArrayShuffle();
        this.effectplayer.play('decision');
        this.setState({ page: 'select' });
    }
    handleClickOthers() {
        window.open("https://www.artec-kk.co.jp/dl/karuta/");
        // this.effectplayer.play('decision').then(() => {
        //     window.open("https://www.artec-kk.co.jp/dl/karuta/");
        // });
    }
    handleClickSelect(voiceType) {
        console.log('handle click select');
        this.StopSound();
        this.effectplayer.play('decision').then(() => {
            this.setState({ page: 'game', voice: voiceType });
            this.voiceplayer.setvoicetype(voiceType);
            this._play();
        });
    }
    handleClickAnswer() {
        console.log('handle click answer');
        this.effectplayer.play('decision');
        console.log(this.state.current);
        this.setState({ page: 'answer' });
    }
    handleClickCard() {
        this.StopSound();
        this.effectplayer.play('cancel');
        this.setState({ page: 'game' });
    }
    handleClickModal() {
        this.StopSound();
        this.effectplayer.play('cancel');
        this.setState({ page: 'game' });
    }
    handleClickClose() {
        this.effectplayer.play('cancel');
        this.setState({ page: 'game' });
    }
    handleClickRepeat() {
        console.log('handle click repeat');
        this.StopSound();
        this.effectplayer.play('select').then(() => {
            this.effectplayer.play('taiko2').then(() => {
                setTimeout(() => this.voiceplayer.replay(), 500);
            })
        });
    }
    handleClickPrevious() {
        console.log('handle click previous');
        console.log(`state.read.length: [${this.state.read.length}]`);
        if (this.state.read.length <= 1) return;
        this.StopSound();
        const _arr = [...this.state.remaining];
        _arr.push(this.state.current);
        const _read = [...this.state.read];
        const character = _read.pop();
        const count = this.state.count + 1;
        this.setState({ count: count, remaining: _arr, read: _read, current: character }, () => {
            this.voiceplayer.select(character).then(() => {
                this.effectplayer.play('select').then(() => {
                    this.effectplayer.play('taiko2').then(() => {
                        console.log(`character: [${character}]`);
                        setTimeout(() => this.voiceplayer.play(character), 500);
                    })
                })
            })
        });
    }
    handleClickNext() {
        console.log('handle click next');
        console.log(`state.remaining.length: ${this.state.remaining.length}`);
        this.StopSound();
        if (this.state.remaining.length == 0) {
            const count = this.state.count - 1;
            if(count < 0){
                count = 0;
                this.state.count = 0;
            }
            this.setState({ count: count }, () => {
                this.handleClickFinish();
            });
        } else {
            const _arr = [...this.state.remaining];
            const character = _arr.pop();
            const _read = [...this.state.read];
            _read.push(this.state.current);
            this.state.count = this.state.count - 1;
            const count = this.state.count;
            this.setState({ count: count, remaining: _arr, read: _read, current: character }, () => {
                this.voiceplayer.select(character).then(() => {
                    this.effectplayer.play('select').then(() => {
                        this.effectplayer.play('taiko2').then(() => {
                            console.log(`character: [${character}]`);
                            setTimeout(() => this.voiceplayer.play(character), 500);
                        })
                    })
                })
            });
        }
    }
    handleClickFinish() {
        this.StopSound();
        this.effectplayer.play('decision');
        this.setState({ page: 'prompt' });
    }
    handleClickYes() {
        this.StopSound();
        this.effectplayer.play('decision');
        this.setState({ page: 'end' });
        this.announceplayer.play('nanmai');
    }
    handleClickNo() {
        this.StopSound();
        if(this.state.count==0) this.state.count = this.state.count + 1;
        const _number = this.state.count;
        this.setState({ number: _number }, () => {
            this.effectplayer.play('cancel');
            this.setState({ page: 'game' });
        });
    }
    handleClickRestart() {
        this.StopSound();
        this.effectplayer.play('decision');
        this.setState({
            page: 'start',
            current: null,
            remaining: [...VoicePlayer.CARD],
            read: []
        });
    }
    _play() {
        console.log('_play');
        this.StopSound();
        const _arr = [...this.state.remaining];
        const character = _arr.pop();
        const _read = [...this.state.read];
        _read.push(this.state.current);
        this.setState({ remaining: _arr, read: _read, current: character }, () => {
            this.voiceplayer.select(character).then(() => {
                this.effectplayer.play('taiko2').then(() => {
                    console.log(`character: [${character}]`);
                    setTimeout(() => this.voiceplayer.play(character), 500);
                })
            })
        });
    }
    render() { //setStateで変更した内容のみrenderで見ることが可能
        return (
            <div className="App">
                {this.state.page === 'start' ?
                    <ViewStart
                        onClickStart={this.handleClickStart}
                        onClickOthers={this.handleClickOthers}
                    /> : null
                }
                {this.state.page === 'select' ?
                    <ViewSelect onClickSelect={this.handleClickSelect} /> : null
                }
                {this.state.page === 'game' || this.state.page === 'prompt' || this.state.page === 'answer' ?
                    <ViewGame
                        page={this.state.page}
                        number={this.state.count}
                        current={this.state.current}
                        onClickRepeat={this.handleClickRepeat}
                        onClickAnswer={this.handleClickAnswer}
                        onClickPrevious={this.handleClickPrevious}
                        onClickNext={this.handleClickNext}
                        onClickFinish={this.handleClickFinish}
                        onClickYes={this.handleClickYes}
                        onClickNo={this.handleClickNo}
                        onClickCard={this.handleClickCard}
                        onClickClose={this.handleClickClose}
                        onClickModal={this.handleClickModal}
                    /> : null
                }
                {this.state.page === 'end' ?
                    <ViewEnd onClickRestart={this.handleClickRestart}></ViewEnd> : null
                }
            </div>
        );
    }
}

export default App;
